import { useState } from "react";
import { VeryBtnFill } from "../../common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../common/v2/VeryBtnFill/classVeryBtnFill";
import { VeryInput } from "../../common/v2/VeryInput";
import Styles from "./styles";
import { useCancellationsContext } from "../../../context";

const DURATIONS = [
  { key: "1h",  label: "1 hora" },
  { key: "4h",  label: "4 horas" },
  { key: "24h", label: "24 horas" },
  { key: "48h", label: "48 horas" },
  { key: "7d",  label: "7 días" },
];

export const ModalBlockDriver = () => {
  const cancellations = useCancellationsContext();
  const [duration, setDuration] = useState("24h");
  const [reason, setReason]     = useState("");

  const onConfirm = () => {
    cancellations.execBlockDriver({ blockDuration: duration, blockReason: reason });
  };

  const onClose = () => {
    setDuration("24h");
    setReason("");
    cancellations.closeModalBlockDriver();
  };

  return (
    <Styles.Modal
      CSS={["modalBlockDriver"]}
      title="Bloquear conductor temporalmente"
      isVisible={cancellations.modalBlock.show}
      onClickClose={onClose}
      buttons={[
        <VeryBtnFill
          CSS={["btnModal"]}
          label="Confirmar bloqueo"
          isLoading={cancellations.actionLoading}
          onClick={onConfirm}
          colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
        />,
      ]}
    >
      <label className="txt-label">Duración del bloqueo</label>
      <div className="div-durationOptions">
        {DURATIONS.map(({ key, label }) => (
          <button
            key={key}
            className={`btn-duration${duration === key ? " selected" : ""}`}
            onClick={() => setDuration(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <VeryInput
        title="Motivo (opcional)"
        isEditable
        placeHolder="Ej. Múltiples cancelaciones en menos de 1 hora"
        text={reason}
        onChangeText={setReason}
      />
    </Styles.Modal>
  );
};
